import React from "react";
import { useLocation, Link } from "wouter";
import { Home } from "lucide-react";

const labelMap: Record<string, string> = {
  "introduction": "Introduction",
  "questions": "Assessment Questions",
  "blockers": "Implementation Blockers",
  "results": "Results"
};

interface BreadcrumbTrailProps {
  section: string;
  index?: number;
  total?: number;
  projectData?: {
    id: string;
    name: string;
    client_org?: string;
  };
}

export const BreadcrumbTrail = ({ section, index, total, projectData }: BreadcrumbTrailProps) => {
  const [location] = useLocation();
  const pathParts = location.split("/").filter(Boolean);
  
  // Check if we're on the results page to conditionally disable the maturity assessment link
  const isResultsPage = section === "results" || location.includes("/maturity/results");

  return (
    <nav className="text-sm text-gray-400 flex gap-2 items-center mb-4">
      <Link to="/" className="hover:underline text-foreground cursor-pointer flex items-center">
        <Home className="h-4 w-4" />
      </Link>
      <span>/</span>
      {projectData && (
        <>
          <span className="text-foreground">
            {projectData.client_org}
          </span>
          <span>/</span>
        </>
      )}
      {isResultsPage ? (
        <span className="text-foreground">Maturity Assessment</span>
      ) : (
        <Link
          to={projectData ? `/projects/${projectData.id}/maturity/assessment` : "/maturity"}
          className="hover:underline text-foreground cursor-pointer"
        >
          Maturity Assessment
        </Link>
      )}
      {labelMap[section] && (
        <>
          <span>/</span>
          <span>{labelMap[section]}</span>
        </>
      )}
      {typeof index === "number" && total && (
        <>
          <span>/</span>
          <span>Question {index + 1} of {total}</span>
        </>
      )}
    </nav>
  );
};